import React from 'react';
import "./CustomButton.css"


type CustomButtonProps = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  style?: React.CSSProperties
  children: React.ReactNode;
};

const CustomButton: React.FC<CustomButtonProps> = ({
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  children,
  style
}) => {
  return (
    <button
    onClick={disabled ? undefined : onClick}
      className={`custom-button ${className} ${disabled ? "disabled" : ""}`}
      disabled={disabled}
      style={style}
      type={type}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      {children}
    </button>
  );
};

export default CustomButton;